const rankings = [
  { rank: 1, title: '长安如故', category: '古装传奇', heat: '9.8', episodes: '48集全', isHot: true },
  { rank: 2, title: '深渊之光', category: '悬疑刑侦', heat: '9.6', episodes: '更新至32集', isHot: true },
  { rank: 3, title: '星辰大海', category: '都市情感', heat: '9.4', episodes: '36集全', isNew: true },
  { rank: 4, title: '九州风云录', category: '玄幻史诗', heat: '9.3', episodes: '更新至40集', isHot: true },
  { rank: 5, title: '岁月如歌', category: '年代温情', heat: '9.1', episodes: '42集全', isNew: true },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时追踪全网热度，精选本周最受欢迎的电视剧，热门新剧与高分经典一网打尽
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-3 md:gap-5 p-4 md:p-5 bg-background-50 border border-background-200 rounded-xl hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center font-bold font-heading text-lg md:text-xl ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-background-200 text-foreground-700'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </h3>
                  {item.isHot && (
                    <span className="px-1.5 py-0.5 text-[10px] md:text-xs font-medium text-accent-500 bg-accent-50 rounded whitespace-nowrap">
                      热播
                    </span>
                  )}
                  {item.isNew && (
                    <span className="px-1.5 py-0.5 text-[10px] md:text-xs font-medium text-primary-500 bg-primary-50 rounded whitespace-nowrap">
                      新剧
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-3 mt-1 text-xs md:text-sm text-foreground-500">
                  <span>{item.category}</span>
                  <span>·</span>
                  <span>{item.episodes}</span>
                </div>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <i className="ri-fire-fill text-accent-500 text-sm md:text-base"></i>
                <span className="text-sm md:text-base font-semibold text-accent-500">{item.heat}</span>
              </div>

              <div className="flex-shrink-0 hidden sm:block opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="px-4 py-2 text-xs font-medium text-primary-500 border border-primary-300 rounded-full hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  立即观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}